import React from 'react';
import { MuiDialogue } from '@ace/ace-ui-web';
import { Typography } from '@mui/material';
// Languages
import lang from '../../languages/en.json';

/**
 * Props interface for MarketingDisclaimerDialog component
 */
export interface MarketingDisclaimerDialogProps {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Callback when the dialog is dismissed/closed */
  onClose: () => void;
  /** Callback when the user accepts the disclaimer and proceeds */
  onAccept: () => void;
}

/**
 * MarketingDisclaimerDialog - Disclaimer dialog shown before navigating to the Marketing Planning Tool.
 * User must click "Accept to proceed" to continue, or close to cancel.
 */
const MarketingDisclaimerDialog: React.FC<MarketingDisclaimerDialogProps> = ({
  isOpen,
  onClose,
  onAccept,
}) => (
  <MuiDialogue
    open={isOpen}
    hideTriggerButton
    dialogTitle={lang.marketing.disclaimer.title}
    onClose={onClose}
    onSave={onAccept}
    saveButtonText={lang.marketing.disclaimer.acceptButton}
    dialogContent={
      <Typography variant="body1">{lang.marketing.disclaimer.body}</Typography>
    }
  />
);

export default MarketingDisclaimerDialog;
